import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccordionVM } from '../accordion/accordion.model';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class SmrutiService {

  constructor(private httpClient: HttpClient) { }

  public getSmruti(stype: SmrutiType): Observable<AccordionVM[]>
  {
    return this.httpClient.get<AccordionVM[]>(Constants.smruti + stype);
  }

  public getStotra(): Observable<AccordionVM[]>
  {
    return this.httpClient.get<AccordionVM[]>(Constants.stotra);
  }
}

export enum SmrutiType
{
    smruti,
    vruddhachar,
    adnyat
}

